import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { UploaderOptions, UploadOutput } from 'ngx-uploader';
import { forkJoin } from "rxjs";
import {AuthRESTService} from '../../services/rest/auth-rest.service';
import {DomSanitizer, SafeUrl} from '@angular/platform-browser';
import Commons from '../../pages/commons';


@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.css']
})
export class FileUploadComponent extends Commons implements OnInit {
	@Input() imageUrls: string [];
	@Input() saveUrl: string;
	@Input() label: string;
	@Input() deleteUrl: any;
	@Input() isForDownload: boolean = false;
	@Input() base64mode: boolean = false;
	@Input() allowedFileTypes: string = "image/*";
	@Input() base64: { value: string } = { value: '' };
	@Input() verified: boolean = false;
	@Output() onChange = new EventEmitter<[string]>(); // list of urls or ids
	imageSrcs: SafeUrl [];
	isUploading: boolean;
	public logoUploadOptions: UploaderOptions;
	public hasBaseDropZoneOverLogo: boolean;

	constructor(private rest: AuthRESTService, toastr: ToastrService, translate: TranslateService, private sanitizer:DomSanitizer) {
		super(toastr, translate);
		this.sanitizer = sanitizer;
	}

	ngOnInit() {
		this.imageSrcs = [];
		this.isUploading = false;
	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes.saveUrl) {
			this.saveUrl = changes.saveUrl.currentValue;
		}
		if (changes.deleteUrl) {
			this.deleteUrl = changes.deleteUrl.currentValue;
		}
		if (changes.isForDownload) {
			this.isForDownload = changes.isForDownload.currentValue;
		}
		if (changes.imageUrls) {
			this.imageUrls = changes.imageUrls.currentValue;
			this.setImageSrcs();
		}
    }

	setImageSrcs() {
		this.imageSrcs = [];
		this.isUploading = true;

		forkJoin(this.imageUrls.map((url) => {
			return this.rest.get(url, { observe: 'response', responseType: 'blob' });
		})).subscribe(results => {
			this.isUploading = false;
			results.forEach((res) => {
				if (res.status === 200) {
					this.imageSrcs.push(this.sanitizer.bypassSecurityTrustUrl(window.URL.createObjectURL(res.body)));
				}
			});
		}, err => {
			this.isUploading = false;
		});
	}
	deleteImages() {
		let restCalls = [];
		if (Array.isArray(this.deleteUrl)) {
			restCalls = this.deleteUrl.map((url) => {
				return this.rest.delete(url, { observe: 'response', responseType: 'text' })
			});
		} else {
			restCalls = [this.rest.delete(this.deleteUrl, { observe: 'response', responseType: 'text' })];
		}
		forkJoin(restCalls).subscribe(response => {
			this.onChange.emit(['']);
		}, (err) => {
			this.errorHandler(err);
		});
	}

	deleteBase64() {
		this.base64.value = '';
	}

	onUploadOutput(output: UploadOutput) {
		this.clearNotifications();
		if (output.file != null) {
			if (this.base64mode) {
				try {
					var file = output.file.nativeFile;

					var reader = new FileReader();
					// @ts-ignore

					reader.addEventListener("load", () => {
						this.base64.value = reader.result as string;
					}, false);


					if (file) {
						reader.readAsDataURL(file);
					}
				} catch (e) {
					if ((e instanceof TypeError)) {}
				}
			} else {
				this.isUploading = true;
				let file: File = output.file.nativeFile;
				let formData: FormData = new FormData();
				formData.append('name', file.name);
				formData.append('file', file, file.name);

				this.rest.post(this.saveUrl, formData, { observe: 'response', responseType: 'text' }).subscribe((response) => {
					this.isUploading = false;
					this.onChange.emit(response);
					this.addSuccess('general.saved');
				}, (err) => {
					this.isUploading = false;
					this.errorHandler(err);
				})
			}
		}
	}
}
